import {
  GET_ALL_SIZE_REQUEST,
  GET_ALL_SIZE_SUCCESS,
  GET_ALL_SIZE_FAILURE,
} from "./ActionType";

const initialState = {
  sizes: [],
  loading: false,
  error: "",
};

export const publicSizeReducer = (state = initialState, action) => {
  switch (action.type) {
   
    case GET_ALL_SIZE_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_SIZE_SUCCESS:
      return { ...state, loading: false, error: "", sizes: action.payload };

    case GET_ALL_SIZE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
